import { ROTULO_TAG, type TagChangelog } from '../../shared/changelog';
import { Selo } from './UI';

/** O tipo de uma novidade, escrito: a cor do selo só acompanha a palavra. */
export function SeloTag({ tag }: { tag: TagChangelog }) {
  return <Selo tom={tag === 'novidade' ? 'sucesso' : 'neutro'}>{ROTULO_TAG[tag]}</Selo>;
}
